export default {
	package: null,
	packageList: [],
	totalRows: 0,
}
